<template>
  <div id="UserProfileQuestions" class="mt-3">

     <v-layout column align-center justify-center row  >
          
          
        <svg width="280px" height="140px" viewBox="0 0 544 209" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="2.-myPAbox-Logo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="myPAbox-Logo-(white)" transform="translate(-304.000000, -328.000000)">
                    <g id="myPAbox-Logo" transform="translate(215.000000, 256.000000)">
                        <text id="Search-|-Organize-|-Copy-3" font-family="Helvetica-Light, Helvetica" font-size="38" font-weight="300" letter-spacing="2.18500042" fill="#51535D">
                            <tspan x="106.036495" y="271">Search | Organize | Apply</tspan>
                        </text>
                        <g id="SVG-Layer" transform="translate(82.500000, 0.000000)">
                            <polygon id="Path-2" fill="#525252" fill-rule="nonzero" points="359.428102 95.5058552 359.428102 82.5812049 543.068308 82.5812049 543.068308 216.135924 520.742676 216.135924 359.428102 216.135924 359.428102 201.057165 352.869523 201.057165 352.869523 222.598249 549.626887 222.598249 549.626887 76.1188799 352.869523 76.1188799 352.869523 95.5058552"></polygon>
                            <g id="box" transform="translate(372.000000, 85.750000)" fill="#01579B" font-family="Roboto-Regular, Roboto" font-size="92.0088425" font-weight="normal">
                                <text>
                                    <tspan x="0.79253055" y="96.0337186">box</tspan>
                                </text>
                            </g>
                            <g id="my" transform="translate(0.507872, 87.169826)" fill="#ABABAB" font-family="Roboto-Regular, Roboto" font-size="92.0088425" font-weight="normal">
                                <text>
                                    <tspan x="0.199883633" y="96.797701">my</tspan>
                                </text>
                            </g>
                            <g id="PA" transform="translate(122.690583, 0.725818)" fill="#525252" font-family="Roboto-Black, Roboto" font-size="211.182713" font-weight="700">
                                <text id="P">
                                    <tspan x="0.40527112" y="221.86676">P</tspan>
                                </text>
                                <text id="A">
                                    <tspan x="112.477227" y="221.86676">A</tspan>
                                </text>
                            </g>
                        </g>
                        <g id="Registered-Circle" transform="translate(604.000000, 247.000000)">
                            <circle id="Oval" stroke="#979797" cx="11.6375" cy="11.6375" r="11.1375"></circle>
                            <text id="TM" font-family="Helvetica-Bold, Helvetica" font-size="10.2" font-weight="bold" letter-spacing="0.586500087" fill="#403C3C">
                                <tspan x="3.68737687" y="15.75">TM</tspan>
                            </text>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
       

    </v-layout>
   <v-container class="mt-5 pt-5">
     <v-layout class='justify-center align-center text-center' ><span class="title  ">Tell us about yourself...</span></v-layout>
    <v-card
      class="mx-auto mt-4 elevation-0"
      max-width="500"
      id="buttonShadow"
      >

      <v-card-title class="title font-weight-regular justify-center blue--text text--darken-3">
        <span>{{ currentTitle }}</span>

      </v-card-title>

      <v-window v-model="step">
        <v-window-item :value="1">
          <v-card-text>
          <v-layout row  mt-0 align-center mb-2 >
              <v-checkbox  v-model="applicant_status" class="mt-1 shrink" color="green" value="firstapplicant" hide-details ></v-checkbox>
              <span class="subheading mt-2 "> First-Time Applicant </span>
            </v-layout>
            <v-layout row  mt-0 align-center mb-2 >
              <v-checkbox  v-model="applicant_status" class="mt-1 shrink" color="green" value="reapplicant" hide-details ></v-checkbox>
              <span class="subheading mt-2 "> Re-Applicant </span>
            </v-layout>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="2">
          <v-card-text>
              <v-select
              color="green"
              v-model="applicant_application_cycle"
              :items="['not sure yet', '2021-2022', '2022-2023', '2023-2024', '2024-2025', '2025-2026', '2026-2027']"
              label="Select Application Cycle"
              clearable
              class="mt-1 pt-1"
              >
            </v-select>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="3">
          <div class="pa-3 text-xs-center">
            <v-layout row  mt-0 align-center mb-2 >
              <v-checkbox  v-model="applicant_international_status" class="mt-1 shrink" color="green" value=true hide-details ></v-checkbox>
              <span class="subheading mt-2 "> Yes </span>
            </v-layout>
            <v-layout row  mt-0 align-center mb-2 >
              <v-checkbox  v-model="applicant_international_status" class="mt-1 shrink" color="green" value=false hide-details ></v-checkbox>
              <span class="subheading mt-2 "> No </span>
            </v-layout>
          </div>
        </v-window-item>
      </v-window>


      <v-card-actions>
        <v-btn
          :disabled="step === 1"
          flat
          @click="step--"
        >
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="step !== 3"
          color="info"
          depressed
          @click="step++"
        >
          Next
        </v-btn>
        <v-btn
          v-if="step === 3"
          color="success"
          depressed
          @click="handleSaveUserProfile"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>

   </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      step: 1,
      applicant_status: '',
      applicant_application_cycle: '',
      applicant_international_status: '',
      showSavedButton: false
    }
  },
  methods: {
    ...mapActions(['saveUserProfile']),
    handleSaveUserProfile () {
      const { applicant_status, applicant_application_cycle, applicant_international_status } = this
      const payload = {
        applicant_status,
        applicant_application_cycle,
        applicant_international_status
      }
      this.saveUserProfile(payload)
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
   currentTitle () {
        switch (this.step) {
          case 1: return 'My Application Status'
          case 2: return 'Which Cycle Are You Applying?'
          default: return 'Are You An International Student?'
        }
      }
  },
  watch : {
    showSavedButton (value) {
      if(value === null) {
         console.log(value)
      }



    }
  }
}
</script>

<style scoped>
  #buttonShadow {
    box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  }
</style>



// WEBPACK FOOTER //
// src/components/User/UserProfileQuestions.vue